import { createStore } from "easy-peasy";
import model from "./model";

const store = createStore(model);

export default store;
